import { FC } from 'react';
import { parseISO, format } from 'date-fns';
import styles from './CardStats.module.scss';

interface ICardStats {
  createdAt: string;
  rating: number;
  reviews: number;
}

const CardStats: FC<ICardStats> = ({ createdAt, rating, reviews }) => {
  return (
    <ul className={styles.stats}>
      {createdAt && createdAt.length > 0 && (
        <li className={`${styles.stats__item}`}>
          Добавлено: <time dateTime={createdAt}>{format(parseISO(createdAt), 'dd.MM.yyyy')}</time>
        </li>
      )}
      <li className={styles.stats__item}>Рейтинг: {rating}</li>
      <li className={styles.stats__item}>Отзывы: {reviews} шт.</li>
    </ul>
  );
};
export default CardStats;
